import { Component } from 'components/alerts-actions';

/** @ngInject */
export default function alertsAndActionsRouter($stateProvider) {
    const baseState = {
        url: '/alerts-actions',
        views: {
            content: {
                component: Component.selector
            }
        }
    };

    $stateProvider
        .state('main.alerts-actions', baseState);
}



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions.router.js